import { Container } from 'pixi.js';
import { SCREEN_WIDTH } from '../GameConst';

export const ON_BUTTON_EVENT = 'ON_BUTTON_EVENT';

export class CommonButton extends Container {
    constructor(view, options = {ignorePivot : false, isNegative : false}){
        super();
        if(view)
        {
            this.addChild(view);
            if(!options.ignorePivot)
            {
                this.pivot.set(this.width * 0.5, this.height * 0.5);
            }
        }

        if(options.isNegative) return;

        this.eventMode = 'static';
        this.cursor = 'pointer';
        this.isPointerOut = true;
        this.startPointX = 0
        this.startPointY = 0
        this.on('pointerdown', (e) => {
            this.startPointX = e.clientX;
            this.startPointY = e.clientY;
            this.isPointerOut = false;
        });

        const moveLimit = SCREEN_WIDTH * 0.1;
        this.on('pointermove', (e) => {
            if(!this.isPointerOut)
            {
                const moveX = Math.abs(e.clientX - this.startPointX);
                const moveY = Math.abs(e.clientY - this.startPointY);
                if(moveLimit < moveX || moveLimit < moveY)
                {
                    this.isPointerOut = true;
                }
            }
        });

        this.on('pointerout', () => {
            this.isPointerOut = true;
        });
        this.on('pointercancel', () => {
            this.isPointerOut = true;
        });
        this.on('pointerup', () => {
            if(!this.isPointerOut)
            {
                this.emit(ON_BUTTON_EVENT);
            }
        });
    }
}
